import React from "react";

export default function Loader() {
  return (
    <div className="loader__wrapper">
      <div className="loader"></div>
    </div>
  );
}
